"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 52.92 24",
    width: "52.92",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m51.22 17.41h-2.69a4.36 4.36 0 0 0 -.4-.35 8.21 8.21 0 0 0 -3.42-15.67h-3.83v-.64a.75.75 0 0 0 -.75-.75h-4.31a.76.76 0 0 0 -.75.75v.64h-18.3v-.64a.76.76 0 0 0 -.77-.75h-4.29a.76.76 0 0 0 -.71.75v.64h-2.79a8.21 8.21 0 0 0 -3.42 15.67 3.34 3.34 0 0 0 -.4.35h-2.58a.78.78 0 0 0 -.78.78.75.75 0 0 0 .75.75h1.72a3.69 3.69 0 0 0 -.18 1.11 3.91 3.91 0 1 0 7.08-2.28h1.6a3.87 3.87 0 0 0 -.75 2.28 3.91 3.91 0 0 0 7.75.7h15a3.91 3.91 0 0 0 7.75-.7 3.86 3.86 0 0 0 -.74-2.28h1.58a3.91 3.91 0 1 0 7.08 2.28 3.69 3.69 0 0 0 -.25-1.05h1.83a.75.75 0 0 0 .75-.75.78.78 0 0 0 -.78-.84zm-6 .38.55-.05a2.35 2.35 0 1 1 -.55.05zm-43.72-8.19a6.73 6.73 0 0 1 6.71-6.72h36.5a6.72 6.72 0 0 1 1.21 13.32h-.23a3.85 3.85 0 0 0 -1 .13h-6a3.47 3.47 0 0 0 -2 0h-20.57a3.47 3.47 0 0 0 -2 0h-6a3.85 3.85 0 0 0 -1-.13h-.12a6.72 6.72 0 0 1 -5.5-6.6zm14.22 8.21a2.36 2.36 0 1 1 -1.15 0zm22.63 0a2.36 2.36 0 1 1 -1.15 0zm-30.63 0a2.36 2.36 0 1 1 -.55-.05z"
  }));
};

exports["default"] = _default;